"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Select_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/Components/MAAReports/Select.vue"));
let TableSummaryFilter = class TableSummaryFilter extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    findLabel(id) {
        return this.options.find((o) => o.id === id).label;
    }
    modelEmit(val) {
        if (val == null) {
            val = '';
        }
        this.$emit('changeValue', val);
    }
    get polishDefaultValue() {
        if (this.defaultValue)
            return { 'label': this.defaultValue, 'id': this.defaultValue };
        return null;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFilter.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'Label' })
], TableSummaryFilter.prototype, "label", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFilter.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFilter.prototype, "defaultValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableSummaryFilter.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], TableSummaryFilter.prototype, "clearable", void 0);
TableSummaryFilter = __decorate([
    (0, vue_property_decorator_1.Options)({
        emits: ['update:modelValue', 'changeValue'],
        components: {
            Select: Select_vue_1.default,
            SelectField: bmk_ui_framework_1.SelectField
        },
    })
], TableSummaryFilter);
exports.default = TableSummaryFilter;
